import { render } from "./About.vue?vue&type=template&id=4ba4c325&bindings={\"items\":\"data\",\"item\":\"data\",\"form\":\"data\",\"error\":\"data\",\"getProducts\":\"options\",\"updateProduct\":\"options\",\"deleteProduct\":\"options\",\"showForm\":\"options\",\"clearForm\":\"options\",\"createItem\":\"options\",\"updateItem\":\"options\"}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script